import * as React from 'react';

function CopyIcon(props: React.SVGProps<SVGSVGElement>) {
	return (
		<svg width="100%" height="100%" viewBox="0 0 15 16" fill="none" {...props}>
			<rect
				x={4}
				y={1.5}
				width={9}
				height={11}
				rx={1}
				stroke="currentColor"
				strokeLinecap="round"
			/>
			<path
				d="M2 3.5v10a1 1 0 001 1h7"
				stroke="currentColor"
				strokeLinecap="round"
			/>
		</svg>
	);
}

export default CopyIcon;
